import React from 'react'
import "./Footer.css"
import { Link } from 'react-scroll'
import { menu, socialHandles } from '../../data'

const Footer = () => {
  return (
    <footer id='footer'>
      <div className='section__wrapper'>
        <ul className='nav__link__container'>
          {menu.map((list, index) => (
            <Link
              key={index}
              activeClass='active'
              className='tab__item name'
              to={list.name.toLowerCase()}
              spy={true}
              smooth={true}
              offset={-70}
              duration={500}
            >
              {list.name}
            </Link>
          ))}
        </ul>

        <div className='social__handles__container'>
          {socialHandles
            .filter(s => !!s.link) 
            .map((list, index) => (
              <a
                key={index}
                href={list.link}
                className='icon__container social__handles'
                target='_blank'
                rel='noreferrer'
                aria-label={list.name}
                title={list.name}
              >
                {list.icon}
              </a>
            ))
          }
        </div>

        <div className='copyright__container'>
          <h3>Copyright &copy; All rights reserved | 2025</h3>
          <p className='text__muted'>Build With Love By Mahshid Shirazi</p>
        </div>
      </div>
    </footer>
  )
}

export default Footer
